import { apiClient } from '@/lib/api-client';
import type { ApiSuccess } from '@/lib/api-client';
import type { EfDkSettlementDto } from './types';

/**
 * EF×DK Settlement API.
 *
 * Endpoints (SPEC v1.0 Slice 1D — see ef_dk_settlements/routes.rs):
 *   POST /api/monthly-batches/:batchId/ef-dk-settlement  — compute/recompute
 *   GET  /api/monthly-batches/:batchId/ef-dk-settlement  — list for batch
 *   POST /api/ef-dk-settlements/:id/dk-confirm
 *   POST /api/ef-dk-settlements/:id/final-confirm
 *   POST /api/ef-dk-settlements/:id/lock
 *   POST /api/ef-dk-settlements/:id/revise
 */

/** GET the batch's settlements (the page uses the latest header row). */
export const fetchEfDkSettlements = async (batchId: string): Promise<EfDkSettlementDto[]> => {
  const res = await apiClient.get<ApiSuccess<EfDkSettlementDto[]>>(
    `/monthly-batches/${batchId}/ef-dk-settlement`,
  );
  return res.data.data ?? [];
};

/** POST compute/recompute (idempotent) — gated by valuation.read. */
export const recomputeEfDkSettlement = async (batchId: string): Promise<EfDkSettlementDto> => {
  const res = await apiClient.post<ApiSuccess<EfDkSettlementDto>>(
    `/monthly-batches/${batchId}/ef-dk-settlement`,
  );
  return res.data.data;
};

export const dkConfirmEfDkSettlement = async (id: string): Promise<EfDkSettlementDto> => {
  const res = await apiClient.post<ApiSuccess<EfDkSettlementDto>>(
    `/ef-dk-settlements/${id}/dk-confirm`,
  );
  return res.data.data;
};

export const finalConfirmEfDkSettlement = async (id: string): Promise<EfDkSettlementDto> => {
  const res = await apiClient.post<ApiSuccess<EfDkSettlementDto>>(
    `/ef-dk-settlements/${id}/final-confirm`,
  );
  return res.data.data;
};

export const lockEfDkSettlement = async (id: string): Promise<EfDkSettlementDto> => {
  const res = await apiClient.post<ApiSuccess<EfDkSettlementDto>>(`/ef-dk-settlements/${id}/lock`);
  return res.data.data;
};

export const reviseEfDkSettlement = async (id: string): Promise<EfDkSettlementDto> => {
  const res = await apiClient.post<ApiSuccess<EfDkSettlementDto>>(
    `/ef-dk-settlements/${id}/revise`,
  );
  return res.data.data;
};
